type RegionMap<T> = {
  region: string | null | undefined
  default: T
} & Record<string, T>

export const getRegionSpecificValue = <T>(map: RegionMap<T>): T =>
  map.region && map[map.region] !== undefined ? map[map.region] : map.default
